import { Scene, Input } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import SettingsButton from "../../phaser/components/settingsButton";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;

let characterSelected;
let toy1;
let toy2;
let objNames = {};
let timeoutDoor = {};
let timeoutMonito = {};
let timeoutDialog = {};
let footsteps;
let hearts = 1;
let totalHearts = 1;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let hasLightstick = false;
let defaultSettings = 1;
let isTouchDoor = 0;
let toysTouched = 0;
let totalTimer = 30;
let instructionsHandler = 0;
let lastCoordenates = null;

export default class Game5 extends Scene {

    constructor() {
        super({ key: "Game5" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        hasLightstick = false;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 1;
        this.firstStep = true;
        this.isInRedRoom = false;
        this.count = 0;
        totalTimer = 30;
        this.startAll = false;
        this.events.off('buttonNext-dialogModal');
        setLastMovement('down');
    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.isPause = true;
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.isPause = false;
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 5490);
        this.physics.world.setBounds(0, 0, 5490);

        this.ppalSong = this.sound.add(`whatSong`, { loop: true, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }
        this.map = mapHandler(this, 'game5', false, 8, 8);



        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(2);
        this.map.ground.setScale(2);
        this.door = this.map.map.createLayer('Door', this.map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(2);


        this.object = this.map.map.createLayer('Objects', this.map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });
        this.object.setScale(2);

        const tilesetDoo1 = this.map.map.addTilesetImage('game5-door-1', `tilesgame5_door1`, 8, 8);
        this.door1 = this.map.map.createLayer('Door1', tilesetDoo1, 0, 0);
        this.door1.setCollisionByProperty({ collides: true });
        this.door1.setScale(2);
        this.door1.active = false;
        this.door1.visible = false;

        this.exit1 = this.map.map.createLayer('Exit1', this.map.tileset, 0, 0);
        this.exit1.setCollisionByProperty({ collides: true });
        this.exit1.setScale(2);

        this.exit2 = this.map.map.createLayer('Exit2', this.map.tileset, 0, 0);
        this.exit2.setCollisionByProperty({ collides: true });
        this.exit2.setScale(2);

        this.door3Close = this.map.map.createLayer('DoorClose3', this.map.tileset, 0, 0);
        this.door3Close.setCollisionByProperty({ collides: true });
        this.door3Close.setScale(2);

        const tilesetDoo2 = this.map.map.addTilesetImage('game5-door-2', `tilesgame5_door2`, 8, 8);
        this.door2 = this.map.map.createLayer('Door2', tilesetDoo2, 0, 0);
        this.door2.setCollisionByProperty({ collides: true });
        this.door2.setScale(2);
        this.door2.active = false;
        this.door2.visible = false;

        const tilesetDoo3 = this.map.map.addTilesetImage('game5-door-3', `tilesgame5_door3`, 8, 8);
        this.door3 = this.map.map.createLayer('Door3', tilesetDoo3, 0, 0);
        this.door3.setScale(2);
        this.door3.active = false;
        this.door3.visible = false;

        this.darkRoom = this.map.map.createLayer('DarkRoom', this.map.tileset, 0, 0);
        this.darkRoom.setCollisionByProperty({ collides: true });
        this.darkRoom.setScale(2);

        objNames[characterSelected] = this.physics.add.sprite(274, 1340, `${characterSelected}-game5`, 4);
        objNames[characterSelected].setScale(2);
        objNames[characterSelected].setImmovable();

        walkAnimation(this, `${characterSelected}-game5`);
        reposeAnimation(this, `${characterSelected}-game5`);
        turnStaticAnimation(this, `${characterSelected}-game5`);
        upStaticAnimation(this, `${characterSelected}-game5`);
        leftStaticAnimation(this, `${characterSelected}-game5`);
        rightStaticAnimation(this, `${characterSelected}-game5`);
        backStaticAnimation(this, `${characterSelected}-game5`);
        lightstickAnimation(this, `${characterSelected}-game5`);

        toy1 = this.physics.add.sprite(3794, 1482, `monito-game5`);
        toy1.setScale(2);

        toy2 = this.physics.add.sprite(2030, 286, `monito2-game5`);
        toy2.setScale(2);
        toy2.active = false;
        toy2.visible = false;

        this.countdownText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 30, 16, 'pixelfont',`${totalTimer} SEG`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5);
        this.countdownText.visible = false;

        this.anims.create({
            key: `repose-monito-game5`,
            frames: this.anims.generateFrameNumbers('monito-game5', { start: 0, end: 3 }),
            frameRate: 5,
            repeat: -1
        });

        this.anims.create({
            key: `repose-monito2-game5`,
            frames: this.anims.generateFrameNumbers('monito2-game5', { start: 0, end: 3 }),
            frameRate: 5,
            repeat: -1
        });

        this.physics.add.collider(objNames[characterSelected], this.exit1, () => {
            this.startAll = false;
            clearTimeout(timeoutDoor);
            timeoutDoor = setTimeout(() => {

                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        objNames[characterSelected].setPosition(3978, 1232);
                        this.startAll = true;
                        this.cameras.main.fadeIn();
                    }
                });

            }, 1000);
        }, null, this);

        this.physics.add.collider(objNames[characterSelected], this.exit2, () => {
            this.startAll = false;

            clearTimeout(timeoutDoor);
            timeoutDoor = setTimeout(() => {
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        objNames[characterSelected].setPosition(4252, 1232);
                        this.startAll = true;

                        this.cameras.main.fadeIn();
                    }
                });

            }, 1000);
        }, null, this);


        this.physics.add.collider(objNames[characterSelected], walls);
        this.door3CloseCollider = this.physics.add.collider(objNames[characterSelected], this.door3Close);

        this.physics.add.collider(objNames[characterSelected], this.object);

        this.physics.add.overlap(objNames[characterSelected], toy1, function onOverlap() {
            this.helpLightstick.visible = true;

            toy1.anims.play(`repose-monito-game5`, true);

            if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                toy1.visible = false;
                toy1.active = false;
                clearTimeout(timeoutDialog);
                timeoutDialog = setTimeout(() => {
                    toysTouched++;
                    if (toysTouched === 1) {
                        objNames[characterSelected].setVelocity(0, 0);
                        this.pauseTimer = true;
                        this.startAll = false;
                        this.showingInstruction = true;
                       
                        objNames[characterSelected].anims.play(`repose-${characterSelected}-game5`);
                        // this.dialogModal._createWindow(this, 'first-toy', null, true);
                        this.dialogModal._createImageDialog(this, 'first-toy');

                        this.dialogModal.setText("A door opened! \nBut before I move forward, I need to find these little toys \nthat are around here. \nI have a feeling I need to hurry...".toUpperCase(), `${characterSelected}-hallway`, false, false)
                        // objNames[characterSelected].active = false;

                    }

                    if (toysTouched === 2) {
                        this.door2.active = true;
                        this.door2.visible = true;
                        toy1.setPosition(5386, 746);
                        toy1.setTint(0x473334);
                        toy1.active = true;
                        toy1.visible = true;
                        totalTimer += 20;
                    }

                    if (toysTouched === 3) {
                        this.door3Close.active = false;
                        this.door3Close.visible = false;
                        this.physics.world.removeCollider(this.door3CloseCollider);
                        this.door3.active = true;
                        this.door3.visible = true;
                        toy2.active = true;
                        toy2.visible = true;
                        totalTimer += 20;

                    }
                }, 1000);
            }

            clearTimeout(timeoutMonito);

            timeoutMonito = setTimeout(() => {
                toy1.anims.stop();
                this.helpLightstick.visible = false;
            }, 1000);

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], toy2, function onOverlap() {
            this.helpLightstick.visible = true;

            toy2.anims.play(`repose-monito2-game5`, true);

            if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                toy2.visible = false;
                toy2.active = false;
                clearTimeout(timeoutDialog);
                timeoutDialog = setTimeout(() => {
                    hasLightstick = true;
                    if(this.isMobile) {
                        this.joystickManager.setLightStickValue(hasLightstick);
                    }
                    // MOSTRAR DIALOGO
                    clearInterval(this.countdown);
                    this.countdownText.visible = false;

                    this.startAll = false;
                    this.showingInstruction = true;
                    
                    // objNames[characterSelected].active = false;
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game5`);
                    // this.dialogModal._createWindow(this, 'dialog-win', null, true);
                    this.dialogModal._createImageDialog(this, 'dialog-win');

                    this.dialogModal.setText("Great! \nI got my lightstick back! \nI need to find the exit.".toUpperCase(),`${characterSelected}-hallway` ,false, false);
                }, 1000);
            }

            clearTimeout(timeoutMonito);

            timeoutMonito = setTimeout(() => {
                toy2.anims.stop();
                this.helpLightstick.visible = false;

            }, 1000);

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );


        this.physics.add.overlap(objNames[characterSelected], this.darkRoom, function onOverlap() {
            // objNames[characterSelected].alpha = 0.5;
            objNames[characterSelected].setTint(0x473334);

            clearTimeout(this.timeoutRedRoom);
            this.timeoutRedRoom = setTimeout(() => {
                objNames[characterSelected].clearTint();
            }, 100);
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.door1, function onOverlap() {
            if (this.door1.active) {
                if (isTouchDoor === 500) {
                    clearTimeout(timeoutDoor);
                    timeoutDoor = setTimeout(() => {
                        isTouchDoor = 0;
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                objNames[characterSelected].setPosition(3978, 942);
                                this.cameras.main.fadeIn();
                            }
                        });
                    });
                }

                isTouchDoor++;
            }

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.door2, function onOverlap() {
            if (this.door2.active) {
                if (isTouchDoor === 500) {
                    clearTimeout(timeoutDoor);
                    timeoutDoor = setTimeout(() => {
                        isTouchDoor = 0;
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                objNames[characterSelected].setPosition(4224, 940);
                                this.cameras.main.fadeIn();
                            }
                        });
                    });
                }

                isTouchDoor++;
            }

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.collider(objNames[characterSelected], this.door, () => {
            this.textHoldOn.visible = true;
            clearTimeout(timeoutDoor);
            timeoutDoor = setTimeout(() => {
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        objNames[characterSelected].setPosition(3062, 1438);
                        this.textHoldOn.visible = false;
                        // objNames[characterSelected].active = false;
                        // setLastMovement('down');
                        objNames[characterSelected].anims.play(`repose-${characterSelected}-game5`);
                        this.cameras.main.fadeIn();
                        // this.dialogModal._createWindow(this, 'first-door', null, true);
                        this.dialogModal._createImageDialog(this, 'first-door');

                        this.dialogModal.setText("I'm in. Look at that little toy on the floor! \nI wonder what it is... \nMaybe I should go investigate.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                        this.startAll = false;
                        this.showingInstruction = true;
                        

                    }
                });
            }, 1500);
        }, null, this);


        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);


        window.addEventListener("blur", () => {
            this.isPause = true;
            this.buttonPause.pauseByEvent();
         });
     
        //  document.addEventListener('visibilitychange', () => {
        //      if (document.visibilityState !== 'visible') {
        //          this.buttonPause.pauseByEvent();
        //  } 
        //  });

        objNames[characterSelected].anims.play(`repose-${characterSelected}-game5`);
        // this.dialogModal._createWindow(this, 'start-dialog', null, true);
        this.showingInstruction = true;
        this.dialogModal._createImageDialog(this, 'start-dialog');

        this.dialogModal.setText("Wow! It seems like I'm in an abandoned city. \nThe door of the building at the end of the street is open, \nmaybe one lightstick is hidden there...".toUpperCase(), `${characterSelected}-hallway`, false, false);

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            switch (data.id) {
                case 'first-door':
                    if (instructionsHandler === 1) {
                        // objNames[characterSelected].active = true;
                        this.dialogModal.close();
                        instructionsHandler = 0;
                        this.countdownText.visible = true;
                        this.countdown = setInterval(() => {
                            if (!this.isPause && !this.pauseTimer) {
                                totalTimer--;
                            }
                            if (totalTimer <= 0) {
                                clearInterval(this.countdown);
                                this.updateCounter();
                            }
                        }, 1000);
                        this.startAll = true;
                        this.showingInstruction = false;
                        
                    }
                    break;
                case 'first-toy':
                    if (instructionsHandler === 1) {
                        this.pauseTimer = false;
                        // objNames[characterSelected].active = true;
                        this.dialogModal.close();
                        instructionsHandler = 0;
                        this.door1.active = true;
                        this.door1.visible = true;
                        toy1.setPosition(3272, 198);
                        toy1.active = true;
                        toy1.visible = true;
                        totalTimer += 20;
                        this.startAll = true;
                        this.showingInstruction = false;
                        

                    }
                    break;
                case 'start-dialog':
                    if (instructionsHandler === 1) {
                        this.dialogModal.close();
                        instructionsHandler = 0;
                        this.startAll = true;
                        this.showingInstruction = false;

                        if(this.isMobile) {
                            this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game5`, 300);
                            this.joystickManager.createJoystick();
                            this.joystickManager.activate(hasLightstick);
    
                        }
                        
                    }
                    break;
                case 'dialog-win':
                    if (instructionsHandler === 1) {
                        // objNames[characterSelected].active = true;
                        this.dialogModal.close();
                        instructionsHandler = 0;
                        this.startAll = true;
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                objNames[characterSelected].setPosition(270, 1294)

                                setTimeout(() => {
                                    let total = JSON.parse(localStorage.getItem('noL'));
                                    if (total) {
                                        if (!total.includes(5)) {
                                            total.push(5);
                                            localStorage.setItem('noL', JSON.stringify(total));

                                        }
                                    } else {
                                        localStorage.setItem('noL', JSON.stringify([5]));
                                    }

                                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                        if (progress === 1) {
                                            footsteps.stop();
                                            this.ppalSong.stop();
                                            this.scene.stop();
                                            if(this.joystickManager) {
                                                this.joystickManager.destroyTest();
                                                this.joystickManager = null;
                                            }
                                            this.events.off('buttonNext-dialogModal');

                                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 5, lastCoordenates });
                                        }
                                    });
                                }, 3000);
                                this.cameras.main.fadeIn();
                            }
                        });
                    }
                    break;
            }
        })

        if (this.isMobile) {

            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.lightstickCounter = new LightstickCounter(this);

        this.screenCenterX = (this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50;
        this.screenCenterY = this.cameras.main.worldView.y + 10;

        // this.helpLightstick = this.add.text(0, 0, 'INTERACT: SPACEBAR', { font: "30px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 3 }).setOrigin(1, 0).setVisible(false);
        this.helpLightstick = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);
        this.textHoldOn = this.add.bitmapText(0, 20, 
            'pixelfont', "Hold On . . .".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);

    }

    updateCounter() {
        this.tweens.add({
            targets: redHeartsObject[hearts - 1],
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            ease: 'Linear',
            duration: 200
        });

        var heartsTimeline = this.tweens.createTimeline();
        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 1.5,
            scaleY: 1.5,
            ease: 'Power1',
            duration: 200
        });
        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 3,
            scaleY: 3,
            ease: 'Power1',
            duration: 200
        });
        heartsTimeline.play();
        hearts -= 1;
        setTimeout(() => {
            if (hearts <= 0) {
                if(this.joystickManager) {
                    this.joystickManager.destroyTest();
                    this.joystickManager = null;
                }
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        clearInterval(this.countdown);
                        footsteps.stop();
                        this.ppalSong.stop();
                        this.scene.stop();
                        this.events.off('buttonNext-dialogModal');
                        this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 5, lastCoordenates });
                    }
                });

            }

        }, 1000);

    }


    update() {


        this.helpLightstick.setPosition(this.screenCenterX + 60, this.screenCenterY + 30);
        this.textHoldOn.setPosition(this.screenCenterX, this.screenCenterY + 15);


        if (this.startAll) {
            if (!this.isMobile) {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game5`, hasLightstick);
            } else {
                if(this.joystickManager) {

                    this.joystickManager.show();
                }
            }

            if (this.countdownText.visible) {
                this.countdownText.setText(`${totalTimer} SEG`);
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }

        }else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game5`);
                    this.joystickManager.pause();
                }
            }
        }

    }

}